import React from 'react'
import {getTournamentsystem} from "../../../../constants/tournamentSystems";
import {AustragungsortMapIcon} from "../tournaments/AustragungsortComp";
import {formatEntfernung} from "../tournaments/UmkreissucheComp";

const MONATE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
const WOCHENTAGE = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

// beginnString kommt vom Backend als dd.MM.yyyy
function parseDatum(tournament) {
    const treffer = /^(\d{2})\.(\d{2})\.(\d{4})/.exec(tournament.beginnString || "");
    if (!treffer) {
        return undefined;
    }
    return new Date(Number(treffer[3]), Number(treffer[2]) - 1, Number(treffer[1]));
}

function getUhrzeit(tournament) {
    if (tournament.beginnNurMitTagesangabe || !tournament.beginnMitUhrzeitString || tournament.beginnMitUhrzeitString.length < 16) {
        return undefined;
    }
    return tournament.beginnMitUhrzeitString.substring(11) + " Uhr";
}

function getDartTypeBezeichnung(tournament) {
    if (tournament.online) {
        return "Online";
    }
    if (tournament.dartType === "STEELDARTS") {
        return "Steeldarts";
    }
    if (tournament.dartType === "EDART") {
        return "E-Dart";
    }
    return undefined;
}

/**
 * Tabelle der Events, nach Monat gruppiert. Die Reihenfolge vom Backend bleibt erhalten.
 * Auf schmalen Bildschirmen werden die Spalten einer Zeile untereinander dargestellt.
 *
 * @param onOpenEventOperator ohne Angabe wird die Spalte Veranstalter nicht angezeigt (z.B. auf der Veranstalterseite)
 * @param nachMonatGruppieren false, wenn die Events ohne Monatszeilen angezeigt werden sollen (z.B. Live-Events)
 */
export default function EventListe({tournaments, onOpen, onOpenEventOperator, live, leerText, nachMonatGruppieren = true}) {

    if (!tournaments || tournaments.length === 0) {
        return <p className="dhpt-hinweis dhte-leer">{leerText || "Aktuell keine Events vorhanden."}</p>
    }

    const mitVeranstalter = onOpenEventOperator !== undefined;

    const gruppen = [];
    for (const tournament of tournaments) {
        const datum = parseDatum(tournament);
        const key = !nachMonatGruppieren ? "alle" : datum ? datum.getFullYear() + "-" + datum.getMonth() : "ohne";
        const letzte = gruppen[gruppen.length - 1];
        if (letzte && letzte.key === key) {
            letzte.tournaments.push(tournament);
        } else {
            gruppen.push({key, titel: datum ? MONATE[datum.getMonth()] + " " + datum.getFullYear() : "Ohne Datum", tournaments: [tournament]});
        }
    }

    return <div className="dhte-tabelle-rahmen">
        <table className={"dhte-tabelle" + (mitVeranstalter ? "" : " dhte-ohne-veranstalter")}>
            <thead>
            <tr>
                <th scope="col">Datum</th>
                <th scope="col">Event</th>
                {mitVeranstalter && <th scope="col">Veranstalter / Ort</th>}
                {!mitVeranstalter && <th scope="col">Ort</th>}
            </tr>
            </thead>
            {gruppen.map(gruppe => <tbody key={gruppe.key + "_" + gruppe.tournaments[0].id}>
            {nachMonatGruppieren &&
                <tr className="dhte-monat-zeile">
                    <th scope="colgroup" colSpan={3}>{gruppe.titel}<span>{gruppe.tournaments.length}</span></th>
                </tr>
            }
            {gruppe.tournaments.map(tournament => <EventZeile key={tournament.id} tournament={tournament} live={live}
                                                              mitVeranstalter={mitVeranstalter}
                                                              onOpen={onOpen} onOpenEventOperator={onOpenEventOperator}/>)}
            </tbody>)}
        </table>
    </div>
}

function EventZeile({tournament, live, mitVeranstalter, onOpen, onOpenEventOperator}) {
    const datum = parseDatum(tournament);
    const uhrzeit = getUhrzeit(tournament);
    const dartType = getDartTypeBezeichnung(tournament);
    const system = getTournamentsystem(tournament.turniersystem);
    const veranstalter = tournament.eventOperatorBezeichnung !== null && tournament.eventOperatorBezeichnung !== undefined
        ? tournament.eventOperatorBezeichnung : tournament.leagueOperatorBezeichnung;
    const ort = tournament.online ? undefined : [tournament.austragungsortPLZ, tournament.austragungsortOrt].filter(wert => wert).join(" ");
    const entfernung = formatEntfernung(tournament.entfernungKm);

    const oeffneVeranstalter = (event) => {
        // sonst wird zusätzlich das Event geöffnet
        event.stopPropagation();
        onOpenEventOperator(tournament);
    }

    return <tr className="dhte-zeile" onClick={() => onOpen(tournament)}>
        <td className="dhte-spalte-datum">
            {datum
                ? <><span className="dhte-wochentag">{WOCHENTAGE[datum.getDay()]}</span> {tournament.beginnString}</>
                : "–"}
            {uhrzeit && <div className="dhte-leise">{uhrzeit}</div>}
        </td>
        <td className="dhte-spalte-event">
            <button type="button" className="dhte-titel" onClick={(event) => {
                event.stopPropagation();
                onOpen(tournament);
            }}>{tournament.bezeichnung}</button>
            <div className="dhte-tags">
                {live && <span className="dhpt-chip dhpt-chip-live">Live</span>}
                {dartType && <span className="dhte-tag">{dartType}</span>}
                {system && <span className="dhte-tag">{system.text}</span>}
            </div>
        </td>
        <td className="dhte-spalte-ort">
            {mitVeranstalter && veranstalter && (tournament.online || !tournament.eventOperatorId
                ? <div>{veranstalter}</div>
                : <div><button type="button" className="dhte-link" onClick={oeffneVeranstalter}>{veranstalter}</button></div>)}
            {ort &&
                <div className="dhte-leise">
                    {tournament.austragungsortBezeichnung ? tournament.austragungsortBezeichnung + " · " : ""}{ort}
                    {entfernung && <span className="dhte-entfernung">{entfernung}</span>}
                    <AustragungsortMapIcon tournament={tournament} fontSize={13}/>
                </div>
            }
        </td>    </tr>
}
